module.exports = __webpack_public_path__ + "img/2.0ecada00.jpg";